// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2vgSD","label":"LabeledBox_label__UF-0C"};